import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Typography, Box, SelectChangeEvent, MenuItem, Select, Checkbox, FormControlLabel, RadioGroup, Radio, FormLabel, CircularProgress, Divider, FormControl } from '@mui/material';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { useNavigate, useParams } from 'react-router-dom';
import { createProject, setCreateProjectStatus, setUpdateProjectStatus, updateProject, fetchProjectTypes, fetchTaskCategories } from '../../redux/slices/projectSlice/addProjectSlice';
import { STATUS } from '../../utils/status';
import SnackbarNotification from '../snackbar/snackbarNotification';
import { FormField } from '../inputField/textfield';
import { UserRoleSelect } from '../inputField/selectField';
import useStyles from '../../assets/styles/style';
import { Container, CssBaseline } from '@mui/material';
import RichTextEditor from './textEditor';
import { constants } from '../../constants/env';

interface FormState {
  id?: string;
  name: string;
  description: string;
  status: string;
  expert_guidelines: string;
  reviewer_guidelines: string;
  task_guidelines: string;
  //data_category: string;
  //annotation_method_id: string;
  //annotation_method_name: string;
  //annotation_method_value: string;
  task_category_id: string;
  auto_submit_task: boolean;
  is_custom_flow: boolean;
  // custom_flow: string;
  //max_user_per_task: string;
  taskers?: string[];
  reviewers?: string[];
  task_category_value: string;
  task_category_name: string;
  //reviewer_setting: "EDIT" | "PUSHBACK" | "FEEDBACK";
  //review_setting: string[];
  split_screen: boolean;
  is_test_enabled: boolean;
  enable_question_randomization: boolean;
  enable_question_shuffling: boolean;
  enable_options_shuffling: boolean;
  enable_draft_tasks: boolean;
  allow_edit_in_draft: boolean;
}

const ProjectForm = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const [projectDetails, setProjectDetails] = useState<FormState>({
    id: '',
    name: '',
    description: '',
    status: '',
    expert_guidelines: '',
    reviewer_guidelines: '',
    task_guidelines: '',
    //data_category: '',
    //annotation_method_id: '',
    task_category_id: '',
    auto_submit_task: false,
    is_custom_flow: false,
    // custom_flow: '',
    taskers: [''],
    reviewers: [''],
    //reviewer_setting: "EDIT",
    //annotation_method_value: '',
    //annotation_method_name: '',
    task_category_value: '',
    task_category_name: '',
    //review_setting: ['EDIT', 'PUSHBACK', 'FEEDBACK'],
    split_screen: false,
    is_test_enabled: false,
    enable_question_randomization: false,
    enable_question_shuffling: false,
    enable_options_shuffling: false,
    enable_draft_tasks: false,
    allow_edit_in_draft: false,
  });
  const createStatus = useSelector((state: RootState) => state.projects.createStatus);
  const updateStatus = useSelector((state: RootState) => state.projects.updateStatus);
  const getStatus = useSelector((state: RootState) => state.projects.getStatus);
  const projectTypeOptions = useSelector((state: RootState) => state.projects.projectTypeOptions);
  const taskCategoryOptions = useSelector((state: RootState) => state.projects.taskCategoryOptions);
  const [autoSubmitTask, setAutoSubmitTask] = useState<boolean>(false);
  const [customFlow, setCustomFlow] = useState<boolean>(false);
  const [enableDraftTasks, setEnableDraftTasks] = useState<boolean>(false);
  const [allowEditInDraft, setAllowEditInDraft] = useState<boolean>(false);
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const fetchedProject = useSelector((state: RootState) => state.projects.project as Partial<FormState>);
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
  const path = window.location.href.includes('/addproject')
  const { getProjectTypesStatus, getTaskCategoryStatus } = useSelector((state: RootState) => state.projects)
  const createProjectMessage = useSelector((state: RootState) => state.projects.createProjectMessage)
  const updateProjectMessage = useSelector((state: RootState) => state.projects.updateProjectMessage)

  useEffect(() => {
    if (getStatus === STATUS.SUCESS && !path) {
      
      // Set separate state variables
      setAutoSubmitTask(Boolean(fetchedProject.auto_submit_task));
      setCustomFlow(Boolean(fetchedProject.is_custom_flow));
      setEnableDraftTasks(Boolean(fetchedProject.enable_draft_tasks));
      setAllowEditInDraft(Boolean(fetchedProject.allow_edit_in_draft));
      
      
      setProjectDetails({
        id: fetchedProject.id || '',
        name: fetchedProject.name || '',
        description: fetchedProject.description || '',
        status: fetchedProject.status || '',
        expert_guidelines: fetchedProject.expert_guidelines || '',
        reviewer_guidelines: fetchedProject.reviewer_guidelines || '',
        task_guidelines: fetchedProject.task_guidelines || '',
       // data_category: fetchedProject.data_category || '',
        task_category_id: fetchedProject.task_category_id || '',
        auto_submit_task: Boolean(fetchedProject.auto_submit_task),
        is_custom_flow: Boolean(fetchedProject.is_custom_flow),
        // custom_flow: fetchedProject.custom_flow || '',
        //annotation_method_id: fetchedProject.annotation_method_id || '',
        //annotation_method_value: fetchedProject.annotation_method_value || '',
        //annotation_method_name: fetchedProject.annotation_method_name || '',
        task_category_value: fetchedProject.task_category_value || '',
        task_category_name: fetchedProject.task_category_name || '',
        //reviewer_setting: fetchedProject.reviewer_setting || "EDIT",
        //review_setting: fetchedProject.review_setting || ['EDIT', 'PUSHBACK', 'FEEDBACK'],
        split_screen: fetchedProject.split_screen || false,
        is_test_enabled: Boolean(fetchedProject.is_test_enabled),
        enable_question_randomization: Boolean(fetchedProject.enable_question_randomization),
        enable_question_shuffling: Boolean(fetchedProject.enable_question_shuffling),
        enable_options_shuffling: Boolean(fetchedProject.enable_options_shuffling),
        enable_draft_tasks: Boolean(fetchedProject.enable_draft_tasks),
        allow_edit_in_draft: Boolean(fetchedProject.allow_edit_in_draft),
      });

    }
  }, [getStatus, fetchedProject]);

  // useEffect(() => {
  //   if (projectDetails.data_category) {
  //     dispatch(fetchProjectTypes({ paginate: false, data_category: projectDetails.data_category }));
  //   }
  // }, [projectDetails.data_category, dispatch]);

  // useEffect(() => {
  //   if (projectDetails.annotation_method_id) {
  //     dispatch(fetchTaskCategories({ paginate: false, annotation_method: projectDetails.annotation_method_id }));
  //   }
  // }, [dispatch, projectDetails.annotation_method_id]);

  const handleFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setProjectDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleSelectFieldChange = (event: SelectChangeEvent<string>, fieldName: keyof FormState) => {
    const value = event.target.value;
    setProjectDetails((prevDetails) => ({
      ...prevDetails,
      [fieldName]: value,
    }));

    // if (fieldName === 'annotation_method_id') {
    //   const selectedProjectType = projectTypeOptions.find((option: any) => option.id === value);
    //   if (selectedProjectType) {
    //     dispatch(fetchTaskCategories({ annotation_method: selectedProjectType.id, paginate: false }));
    //   }
    // }

    // if (fieldName === 'task_category_id') {
    //   setProjectDetails((prevDetails) => ({
    //     ...prevDetails,
    //     task_category_id: value,
    //   }));
    // }
  };

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;

    if (name === 'auto_submit_task') {
      setAutoSubmitTask(checked);
    } else if (name === 'enable_draft_tasks') {
      setEnableDraftTasks(checked);
      if (!checked) {
        setAllowEditInDraft(false);
      }
    } else if (name === 'allow_edit_in_draft') {
      setAllowEditInDraft(checked);
    }

    setProjectDetails((prevDetails) => ({
      ...prevDetails,
      [name]: checked,
      // if draft tasks disabled, also disable allow_edit_in_draft
      ...(name === 'enable_draft_tasks' && !checked ? { allow_edit_in_draft: false } : {}),
    }));
  };

  // const handleEnableTestChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const { name, checked } = event.target;

  //   setProjectDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [name]: checked,
  //   }));
  // };

  const handleCustomCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;

    setCustomFlow(isChecked);
    setProjectDetails((prevDetails) => ({
      ...prevDetails,
      is_custom_flow: isChecked,
      custom_flow: '',
    }));
  };



  // const handleCheckboxFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const { checked, value } = event.target;

  //   setProjectDetails((prevDetails) => {
  //     let updatedReviewSetting = [...prevDetails.review_setting];

  //     if (checked) {
  //       updatedReviewSetting.push(value);
  //     } else {
  //       updatedReviewSetting = updatedReviewSetting.filter(setting => setting !== value);
  //     }

  //     return {
  //       ...prevDetails,
  //       review_setting: updatedReviewSetting,
  //     };
  //   });
  // };


  const handleSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    dispatch(setUpdateProjectStatus(null));
  };

  const handleFormSubmit = (event: any) => {
    event.preventDefault();
    setFormSubmitted(true);

    const validateProjectDetails = (): { [key: string]: string } => {
      const errors: { [key: string]: string } = {};

      if (!projectDetails?.name?.trim()) {
        errors.name = 'Name is Required';
      }
      if (!projectDetails?.status?.trim()) {
        errors.status = 'Status is Required';
      }
      // if (!projectDetails?.annotation_method_id?.trim()) {
      //   errors.annotation_method_id = 'Project Type is Required';
      // }
      // if (!projectDetails?.task_category_id?.trim()) {
      //   errors.task_category_id = 'Task Type is Required';
      // }
      if (!projectDetails?.reviewer_guidelines) {
        errors.reviewer_guidelines = 'Reviewer Guidelines are Required';
      }
      if (!projectDetails?.expert_guidelines) {
        errors.expert_guidelines = 'Expert Guidelines are Required';
      }
      if (!projectDetails?.task_guidelines) {
        errors.task_guidelines = 'Task Guidelines are Required';
      }
      // if (!projectDetails?.review_setting) {
      //   errors.review_setting = 'Review Settings are Required';
      // }
      // if (projectDetails?.is_custom_flow && !projectDetails.custom_flow) {
      //   errors.custom_flow = 'Custom Flow Type is Required';
      // }
      return errors;
    };


    const errors = validateProjectDetails();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      handleSnackbar('Make sure you fill all required fields.', 'warning');
      return;
    }

    const changedFields = Object.keys(projectDetails).reduce((acc, key) => {
      const fetchedValue = fetchedProject[key as keyof FormState];
      const newValue = projectDetails[key as keyof FormState];

      if (
        newValue !== fetchedValue &&
        (fetchedValue !== '' || newValue !== undefined) &&
        newValue !== ''
      ) {
        (acc as any)[key] = newValue;
      }

      return acc;
    }, {} as { [key: string]: string | boolean | string[] | undefined });

    // if (projectDetails.review_setting.length === 0) {
    //   handleSnackbar('Select reviewer control', 'error');
    //   return;
    // }

    if (id) {

      const error = validateProjectDetails()
      console.log(error)


      if (Object.keys(changedFields).length === 0) {
        handleSnackbar('No changes detected for update.', 'info');
        return;
      }

      dispatch(updateProject({ id, ...changedFields }));
    } else {
      const payload = {
        name: projectDetails.name.trim(),
        description: projectDetails.description.trim(),
        expert_guidelines: projectDetails.expert_guidelines,
        reviewer_guidelines: projectDetails.reviewer_guidelines.trim(),
        task_guidelines: projectDetails.task_guidelines.trim(),
        //data_category: projectDetails.data_category,
        //annotation_method_id: projectDetails.annotation_method_id,
        task_category_id: projectDetails.task_category_id,
        ...(projectDetails.auto_submit_task && { auto_submit_task: autoSubmitTask }),
        ...(projectDetails.is_custom_flow && { is_custom_flow: customFlow }),
        ...(projectDetails.enable_draft_tasks && { enable_draft_tasks: enableDraftTasks }),
        ...(projectDetails.allow_edit_in_draft && { allow_edit_in_draft: allowEditInDraft }),
        // ...(projectDetails.is_custom_flow === true && { custom_flow: projectDetails.custom_flow }),
        status: projectDetails.status,
        //review_setting: projectDetails.review_setting,
        split_screen: projectDetails?.split_screen,
        ...(projectDetails.is_test_enabled && { is_test_enabled: projectDetails.is_test_enabled }),
      };

      dispatch(createProject(payload));
    }
  };


  useEffect(() => {
    const handleUpdateStatus = () => {
      if (updateStatus === STATUS.SUCESS) {
        handleSnackbar(updateProjectMessage, 'success');
        window.location.reload();
        dispatch(setUpdateProjectStatus(STATUS.NOT_STARTED));
      }

      if (updateStatus === STATUS.FAILED) {
        handleSnackbar(updateProjectMessage, 'error');
        dispatch(setUpdateProjectStatus(STATUS.NOT_STARTED));
      }
    };

    handleUpdateStatus();
    return () => {
      if (updateStatus === STATUS.SUCESS || updateStatus === STATUS.FAILED) {
        dispatch(setUpdateProjectStatus(STATUS.NOT_STARTED));
      }
    };
  }, [updateStatus, navigate, dispatch]);

  useEffect(() => {
    const handleCreateStatus = () => {
      if (createStatus === STATUS.SUCESS) {
        handleSnackbar(createProjectMessage, 'success');
        setTimeout(() => {
          navigate('/projects');
        }, 1000);
      }
      if (createStatus === STATUS.FAILED) {
        handleSnackbar(createProjectMessage, 'error');
      }
    }
    handleCreateStatus();
    return () => {
      if (createStatus === STATUS.SUCESS || createStatus === STATUS.FAILED) {
        dispatch(setCreateProjectStatus(STATUS.NOT_STARTED));
      }
    };
  }, [createStatus, updateStatus, navigate, dispatch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setProjectDetails((prevState) => ({
      ...prevState,
      split_screen: event.target.value === 'splitScreen'
    }));
  };

  const handleExpertGuidlines = (newContentHTML: { json: string; html: string }) => {
    setProjectDetails((prevState) => ({
      ...prevState,
      expert_guidelines: newContentHTML.html,
    }));
  };

  const handleReviewerGuidlines = (newContentHTML: { json: string; html: string }) => {
    setProjectDetails((prevState) => ({
      ...prevState,
      reviewer_guidelines: newContentHTML.html,
    }));
  };

  const handleTaskerGuidlines = (newContentHTML: { json: string; html: string }) => {
    setProjectDetails((prevState) => ({
      ...prevState,
      task_guidelines: newContentHTML.html,
    }));
  };

  return (
    <>
      <Box className={classes.formContainer}>
        <div>
        <div style={{ display: 'flex', marginLeft: '20px' }}>
          <FormField
            label="Project Name"
            placeholder="Enter Project Name"
            name="name"
            // disabled={!constants.CREATE_PROJECT_FEATURE}
            value={projectDetails.name}
            onChange={handleFieldChange}
            error={formSubmitted && formErrors.name ? formErrors.name : ''}
            textFieldSx={{ marginRight: '20px' }}
          />
          <FormField
            label="Project Description"
            placeholder="Enter Project Description"
            name="description"
            // disabled={!constants.CREATE_PROJECT_FEATURE}
            value={projectDetails.description}
            onChange={handleFieldChange}
            error={formSubmitted && formErrors.description ? formErrors.description : ''}
            textFieldSx={{ marginRight: '20px' }}
          />
          <div style={{ display: 'flex', flexDirection: 'column', marginRight: '20px', width: '32%' }}>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Project Status</Typography>
            <Select
              name="annotation_method_id"
              value={projectDetails.status}
              onChange={(e) => handleSelectFieldChange(e, 'status')}
              error={formSubmitted && !!formErrors.status}
              size='small'
              displayEmpty
            >
              <MenuItem value="" disabled>Select Project Status</MenuItem>
              <MenuItem value="DRAFT">Draft</MenuItem>
              <MenuItem value="ACTIVE">Active</MenuItem>
              <MenuItem value="COMPLETED">Completed</MenuItem>
              <MenuItem value="PUBLISHED">Published</MenuItem>
            </Select>
            {formSubmitted && formErrors.status && (
              <Typography variant="body2" color="error">
                {formErrors.status}
              </Typography>
            )}
          </div>
        </div>
        {/* <UserRoleSelect
            label='Project Status'
            value={projectDetails.status}
            onChange={(e) => handleSelectFieldChange(e, 'status')}
            options={[
              { value: 'DRAFT', label: 'Draft' },
              { value: 'ACTIVE', label: 'Active' },
              { value: 'COMPLETED', label: 'Completed' },
              { value: 'PUBLISHED', label: 'Published' },
            ]}
            error={formSubmitted && formErrors.data_category ? formErrors.data_category : ''}
            typographySx={{ marginTop: '20px' }}
          /> */}
          {/* <div style={{ display: 'flex', flexDirection: 'column', marginRight: '20px', marginLeft: '20px', width: '30%' }}>
            <Typography sx={{ marginTop: '20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Project Type</Typography>
            <Select
              name="annotation_method_id"
              value={projectDetails.annotation_method_id}
              onChange={(e) => handleSelectFieldChange(e, 'annotation_method_id')}
              error={formSubmitted && !!formErrors.annotation_method_id}
              size='small'
              displayEmpty
              disabled={!projectDetails.data_category}
            >
              <MenuItem value="" disabled>Select Project Type</MenuItem>
              {(getProjectTypesStatus === STATUS.SUCESS ? projectTypeOptions : [{ id: projectDetails.annotation_method_id, value: projectDetails.annotation_method_value, name: projectDetails.annotation_method_name }]).map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
            {formSubmitted && formErrors.annotation_method_id && (
              <Typography variant="body2" color="error">
                {formErrors.annotation_method_id}
              </Typography>
            )}
          </div> */}
          {/* <div style={{ display: 'flex', flexDirection: 'column', width: '32%' }}>
            <Typography sx={{ marginTop: '20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Task Type</Typography>
            <Select
              name="task_category_id"
              value={projectDetails.task_category_id}
              onChange={(e) => handleSelectFieldChange(e, 'task_category_id')}
              error={formSubmitted && !!formErrors.task_category_id}
              size='small'
              displayEmpty
              disabled={!projectDetails.annotation_method_id}
            >
              <MenuItem value="" disabled>Select Task Type</MenuItem>
              {(getTaskCategoryStatus === STATUS.SUCESS ? taskCategoryOptions : [{ id: projectDetails.task_category_id, value: projectDetails.task_category_value, name: projectDetails.task_category_name }]).map((option: any) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
            {formSubmitted && formErrors.task_category_id && (
              <Typography variant="body2" color="error">
                {formErrors.task_category_id}
              </Typography>
            )}
          </div> */}
        </div>

        <div style={{ display: 'flex', marginLeft: '20px', marginTop: "25px", gap: 50 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={projectDetails.auto_submit_task}
                onChange={handleCheckboxChange}
                name="auto_submit_task"
                color="primary"
              />
            }

            label={<div><div style={{ fontWeight: 900 }}>Auto Submit Task</div> <Typography style={{ fontSize: "12px" }} >Automatically submits tasks upon time completion.</Typography> </div>}

            style={{ marginTop: '10px' }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={enableDraftTasks}
                onChange={handleCheckboxChange}
                name="enable_draft_tasks"
                color="primary"
              />
            }
            label={<div><div style={{ fontWeight: 900 }}>Enable task in Draft State</div> <Typography style={{ fontSize: "12px" }} >Allow tasks to be created/assigned while project is in draft.</Typography> </div>}
            style={{ marginTop: '10px' }}
          />
          {enableDraftTasks && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={allowEditInDraft}
                  onChange={handleCheckboxChange}
                  name="allow_edit_in_draft"
                  color="primary"
                />
              }
              label={<div><div style={{ fontWeight: 900 }}>Allow edit in draft state</div> <Typography style={{ fontSize: "12px" }} >Permit editing tasks when project is draft.</Typography> </div>}
              style={{ marginTop: '10px' }}
            />
          )}
          {/* {window.location.href.includes('edit') &&
            <FormControlLabel
              control={
                <Checkbox
                  checked={projectDetails.is_test_enabled}
                  onChange={handleEnableTestChange}
                  name="is_test_enabled"
                  color="primary"
                />
              }

              label={<div><div style={{ fontWeight: 900 }}>Is Test Enable</div> <Typography style={{ fontSize: "12px" }} >Mark for enable test.</Typography> </div>}

              style={{ marginTop: '10px' }}
            />
          } */}
        </div>

        {/* {projectDetails.is_custom_flow &&
          <div style={{ display: 'flex', flexDirection: 'column', width: '30%', marginLeft: '20px', marginTop: "30px", }}>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Custom Flow Type</Typography>
            <Select
              name="custom_flow"
              value={projectDetails.custom_flow}
              onChange={(e) => handleSelectFieldChange(e, 'custom_flow')}
              error={formSubmitted && !!formErrors.custom_flow}
              size='small'
              displayEmpty
            >
              <MenuItem value="" disabled>Select Custom Flow Type</MenuItem>
              <MenuItem value="custom_flow_fsl">Custom Flow FSL</MenuItem>
            </Select>
            {formSubmitted && formErrors.custom_flow && (
              <Typography variant="body2" color="error">
                {formErrors.custom_flow}
              </Typography>
            )}
          </div>
        } */}

        <div style={{ marginTop: "20px", marginLeft: "20px" }}>
          <FormLabel id="demo-controlled-radio-buttons-group">User Screen</FormLabel>
          <Divider style={{ width: "5.5%" }} />
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={projectDetails?.split_screen ? 'splitScreen' : 'fullScreen'}
              onChange={handleChange}
            >
              <div style={{ display: "flex" }}>
                <FormControlLabel value="splitScreen" control={<Radio />} label={<div style={{ fontWeight: "600" }}>Split Screen</div>} />
                <FormControlLabel value="fullScreen" control={<Radio />} label={<div style={{ fontWeight: "600" }}>Full Screen</div>} />
              </div>
            </RadioGroup>
          </FormControl>

        </div>

        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', marginTop: "20px" }}>
          <Typography sx={{ marginTop: '10px', marginLeft: '20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Reviewer Guidelines</Typography>
          <Container component="main" maxWidth="xl">
            <CssBaseline />
            <RichTextEditor
              onChange={handleReviewerGuidlines}
              initialContent={path ? '' : fetchedProject.reviewer_guidelines}
            />
            {formSubmitted && formErrors.reviewer_guidelines && (
              <Typography variant="body2" color="error">
                {formErrors.reviewer_guidelines}
              </Typography>
            )}
          </Container>

          <Typography sx={{ marginTop: '10px', marginLeft: '20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Expert Guidelines</Typography>
          <Container component="main" maxWidth="xl">
            <CssBaseline />
            <RichTextEditor
              onChange={handleExpertGuidlines}
              initialContent={path ? '' : fetchedProject.expert_guidelines}
            />
            {formSubmitted && formErrors.expert_guidelines && (
              <Typography variant="body2" color="error">
                {formErrors.expert_guidelines}
              </Typography>
            )}
          </Container>

          <Typography sx={{ marginTop: '10px', marginLeft: '20px', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>Task Guidelines</Typography>
          <Container component="main" maxWidth="xl">
            <CssBaseline />
            <RichTextEditor
              onChange={handleTaskerGuidlines}
              initialContent={path ? '' : fetchedProject.task_guidelines}
            />
            {formSubmitted && formErrors.task_guidelines && (
              <Typography variant="body2" color="error">
                {formErrors.task_guidelines}
              </Typography>
            )}
          </Container>
        </div>
        <br />
        <Button
          type="button"
          onClick={(e) => handleFormSubmit(e)}
          variant="contained"
          sx={{ fontSize: '14px', textTransform: 'none', color: '#FFFFFF', width: '100%', backgroundColor: '#3D85C6', borderRadius: '8px', marginTop: '20px', }}
          disabled={id ? updateStatus === STATUS.PENDING : createStatus === STATUS.PENDING}
          startIcon={id ? updateStatus === STATUS.PENDING ? <CircularProgress /> : null : createStatus === STATUS.PENDING ? <CircularProgress /> : null}
        >
          {id ? "Update Project" : "Add Project"}
        </Button>
        <SnackbarNotification
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />

      </Box >
    </>
  );
};

export default ProjectForm;

